import { render } from "./MemberCrew.vue?vue&type=template&id=0b63e117"
import script from "./MemberCrew.vue?vue&type=script&lang=js"
export * from "./MemberCrew.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__